import React from "react";
import {
  FaExchangeAlt,
  FaHandHoldingUsd,
  FaSeedling,
  FaBalanceScale,
  FaShieldAlt,
} from "react-icons/fa";

function OurDeFiSmartC() {
  const reasons = [
    {
      title: "Decentralized Exchanges (DEXs)",
      desc: "We design and deploy robust smart contracts for DEXs, facilitating secure token swaps, liquidity pooling, and yield farming. With a focus on speed, scalability, and transparency, our smart contracts ensure seamless decentralized trading.",
      icon: <FaExchangeAlt size={30} />,
    },
    {
      title: "Lending & Borrowing Protocols",
      desc: "Our DeFi smart contracts support secure, peer-to-peer lending and borrowing. By implementing collateralized lending protocols, we create opportunities for users to safely lend or borrow assets within a decentralized environment.",
      icon: <FaHandHoldingUsd size={30} />,
    },
    {
      title: "Staking & Yield Farming",
      desc: "Enhance user engagement and incentivize liquidity with our customized staking and yield farming contracts. Our contracts enable users to earn rewards, contributing to the platform's ecosystem growth while fostering user loyalty.",
      icon: <FaSeedling size={30} />,
    },
    {
      title: "Stablecoins & Asset Management",
      desc: "We create smart contracts for stablecoins and decentralized asset management solutions, enabling users to securely manage their assets with minimal volatility. From asset tokenization to secure fund management, our contracts bring transparency and trust to asset handling.",
      icon: <FaBalanceScale size={30} />,
    },
    {
      title: "Insurance Protocols",
      desc: "Build trust with decentralized insurance protocols. Our insurance smart contracts offer protection against potential risks, providing users with transparency and security while offering financial coverage for DeFi activities.",
      icon: <FaShieldAlt size={30} />,
    },
  ];
  return (
    <>
      <div className="services-area pt-120 pb-120 mt-5">
        <div className="container text-center">
          <h2 className="title mb-4 " style={{ font: "bold" }}>
            Our DeFi Smart Contract Solutions
          </h2>

          <div className="row g-4 justify-content-center">
            {reasons.map((reason, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="reason-card border-0 p-5 text-center h-100"
                  style={{
                    borderRadius: "32px",
                    background: "#f9faff",
                    border: "1px solid #f0f3ff",
                    transition: "all 0.4s ease",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.boxShadow =
                      "0 25px 50px rgba(0, 0, 0, 0.04)";
                    e.currentTarget.style.borderColor = "#3366ff20";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "#f9faff";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#f0f3ff";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "70px",
                      height: "70px",
                      fontSize: "28px", // untouched
                      backgroundColor: "#ffffff",
                      color: reason.color,
                      borderRadius: "20px",
                      boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                    }}
                  >
                    {reason.icon}
                  </div>

                  <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                    {reason.title}
                  </h5>

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#6c757d",
                      lineHeight: "1.7",
                      marginBottom: 0,
                    }}
                  >
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default OurDeFiSmartC;
